export default __webpack_public_path__ + "static/media/Social-Email.c8a82d1e.svg";